define('adminLisAserieTabs',[
  'module',
  'underscore'
], function(
  module,
  _
) {
  'use strict';

  module.exports = [
    {
      name: 'detail',
      title: _.i18n('lisaseries.details.tabTitle')
    },
    {
      name: 'lisana',
      title: _.i18n('lisaseries.lisana.tabTitle')
    }
  ];
});
